import CSS from "csstype"
import { fonts, Fonts } from "./typography"
import { colors, Palette } from "./palette"

export * from "./typography"
export * from "./palette"
export * from "./layers"
export * from "./global-styles"

/* Not taken from styled-system as it conflicts with React color attribute */
export interface ColorProps {
  color?: CSS.ColorProperty
  bg?: CSS.ColorProperty
}

export class BreakpointsArray extends Array<number> {
  xs: number
  sm: number
  md: number
  lg: number

  constructor(items: Array<number>) {
    super(...items)
    this.xs = 0
    this.sm = items[0]
    this.md = items[1]
    this.lg = items[2]
  }
}

interface ThemeInterface {
  layers: { [key: string]: number }
  breakpoints: BreakpointsArray
  colors: Palette
  fonts: Fonts
  space: string[]
  reducedOpacity: number
  maxWidths: number[]
}

export type Height = (string | number | null)[] & string

/* Our types for 'space', 'fonts' and 'colors' conflict with styled-system defined types so we override them */
export type Theme = ThemeInterface

export const CoveTheme: Theme = {
  colors,
  fonts,
  layers: {
    default: 0,
    middle: 1,
    top: 2,
    navigation: 3,
    menu: 4,
    modalShim: 9998 /* the layer below a modal */,
    modal: 9999
  },
  breakpoints: new BreakpointsArray([669, 948, 1220]),
  space: [
    // /////////////////////////////////
    /* DO NOT EVER MODIFY THIS ARRAY */
    // /////////////////////////////////
    "0", // 0: ~0px
    "0.296rem", // 1: ~5px
    "0.444rem", // 2: ~7px
    "0.667rem", // 3: ~11px
    "1rem", // 4: ~16px
    "1.5rem", // 5: ~24px
    "2.25rem", // 6: ~36px
    "3.375rem", // 7: ~54px
    "5.063rem", // 8: ~81px
    "7.594rem" // 9: ~122px
  ],
  reducedOpacity: 0.75,
  maxWidths: [320, 433, 947, 1219, 1439]
}

export default CoveTheme
